import { FC } from 'react';
import { TEMPLATE_BASE_PATH } from '@/constants';
import * as prismicH from '@prismicio/helpers';
import { BlogPostDocument } from '@/types';
import { getFirstPTextAsDescrition, stripHtml } from '@/utils';
import { BlogPublishDate } from '@/components/Blog/Blog.components';
import { Icon, Link, PrismicImageWithAlt, Sharing } from '@/components';

import classNames from 'classnames';

import styles from './article.module.scss';

const Article: FC<ArticleProps> = ({
  article,
  classCss,
  imageEffect,
  variant = 'default',
}) => {
  const banner =
    article.data?.header_image['Normal Size'] &&
    article.data?.header_image['Normal Size'].url
      ? article.data?.header_image['Normal Size']
      : null;

  const headerText = prismicH.asText(article.data?.header_text);

  const publishDate = article.data?.publish_date;
  const url = article.uid || '';
  const title = stripHtml(headerText);
  const description = getFirstPTextAsDescrition(article.data?.main_content);

  return (
    <article
      className={classNames(
        styles.article,
        variant === 'list' && styles.article__list,
        variant === 'banner' && styles.article__banner,
        variant === 'collection' && styles.article__collection,
        classCss,
        'article',
      )}
    >
      <Link href={`${TEMPLATE_BASE_PATH.BLOG}${url}`}>
        <figure
          className={classNames(styles.article__figure, {
            [styles.article__figure_effect]: imageEffect,
          })}
        >
          <PrismicImageWithAlt
            defaultAlt="Preview image of the article"
            field={banner}
            fill
            noImageContent={<Icon name="image" />}
            showPlaceholderIfEmpty
            style={{ objectFit: 'cover', objectPosition: 'center center' }}
          />
        </figure>
        <div className={styles.article__body}>
          <p className={styles.article__title}>{title}</p>
          <p className={styles.article__description}>{description}</p>
          <div className={styles.article__info}>
            <BlogPublishDate publishAt={publishDate} />
            <Sharing
              className={styles.article__sharing}
              include={['facebook', 'twitter', 'whatsapp']}
              // eslint-disable-next-line max-len
              url={`${process.env.NEXT_PUBLIC_STORE_DOMAIN}${TEMPLATE_BASE_PATH.BLOG}${url}`}
            />
          </div>
        </div>
      </Link>
    </article>
  );
};

interface ArticleProps {
  article: BlogPostDocument;
  classCss?: string;
  imageEffect?: boolean;
  variant?: 'default' | 'list' | 'banner' | 'collection';
}

export { Article };
